module.exports = __webpack_public_path__ + "static/media/laravel.7d604cb1.svg";